<template>
  <div>
    <div class="hero webtrading-bg">
      <div class="inner">
        <h1>{{$t('webTradingTerminalPage.text1')}}</h1>
        <h5 class="subtitle">{{$t('webTradingTerminalPage.text2')}}</h5>
        <div class="hero-btn-container" @click="goContact">
          <BtnPrimary text="Request a Demo" />
        </div>
      </div>
    </div>

    <section class="section3">
      <div class="section-inner">
        <h2 class="section-title">{{$t('webTradingTerminalPage.text3')}}</h2>
        <p>
          {{$t('webTradingTerminalPage.text4')}}
        </p>
        <div class="spacer"></div>
        <div class="col3-grid center">
          <div class="col3-grid-item">
            <div><img src="@/assets/icons/wtt-icon1.svg" alt="" /></div>
            <h5>{{$t('webTradingTerminalPage.text5')}}</h5>
            <p>{{$t('webTradingTerminalPage.text6')}}</p>
          </div>
          <div class="col3-grid-item">
            <div><img src="@/assets/icons/wtt-icon2.svg" alt="" /></div>
            <h5>{{$t('webTradingTerminalPage.text7')}}</h5>
            <p>{{$t('webTradingTerminalPage.text8')}}</p>
          </div>
          <div class="col3-grid-item">
            <div><img src="@/assets/icons/wtt-icon3.svg" alt="" /></div>
            <h5>{{$t('webTradingTerminalPage.text9')}}</h5>
            <p>{{$t('webTradingTerminalPage.text10')}}</p>
          </div>
        </div>
      </div>
    </section>

    <section class="section3 light-gray">
      <div class="section-inner">
        <h2 class="section-title">{{$t('webTradingTerminalPage.text11')}}</h2>
        <div class="spacer"></div>
        <div class="col3-grid center">
          <div class="col3-grid-item">
            <div><img src="@/assets/icons/wtt-icon4.svg" alt="" /></div>
            <h5>{{$t('webTradingTerminalPage.text12')}}</h5>
            <p>{{$t('webTradingTerminalPage.text13')}}</p>
          </div>
          <div class="col3-grid-item">
            <div><img src="@/assets/icons/wtt-icon5.svg" alt="" /></div>
            <h5>{{$t('webTradingTerminalPage.text14')}}</h5>
            <p>{{$t('webTradingTerminalPage.text15')}}</p>
          </div>
          <div class="col3-grid-item">
            <div><img src="@/assets/icons/wtt-icon6.svg" alt="" /></div>
            <h5>{{$t('webTradingTerminalPage.text16')}}</h5>
            <p>{{$t('webTradingTerminalPage.text17')}}</p>
          </div>
        </div>
      </div>
    </section>

    <section class="dark">
      <div class="section-inner">
        <h2 class="section-title">Other Frontends Available</h2>
        <div class="spacer"></div>
        <div class="col4-grid center">
          <div class="col4-grid-item">
            <div><img src="@/assets/icons/wtt-icon7.svg" alt="" /></div>
            <h5 class="opacity">Mobile</h5>
          </div>
          <div class="col4-grid-item">
            <div><img src="@/assets/icons/wtt-icon8.svg" alt="" /></div>
            <h5 class="opacity">Desktop</h5>
          </div>
          <div class="col4-grid-item">
            <div><img src="@/assets/icons/wtt-icon9.svg" alt="" /></div>
            <h5 class="opacity">Chat</h5>
          </div>
          <div class="col4-grid-item">
            <div><img src="@/assets/icons/wtt-icon10.svg" alt="" /></div>
            <h5 class="opacity">Trading Signal</h5>
          </div>
        </div>
      </div>
    </section>

    <section class="">
      <div class="section-inner">
        <h2 class="section-title">Delivery Options</h2>
        <div class="spacer"></div>
        <div class="col3-grid center">
          <div class="col3-grid-item">
            <div><img src="@/assets/icons/wtt-icon11.svg" alt="" /></div>
            <h5>Affordable white-labeling</h5>
          </div>
          <div class="col3-grid-item">
            <div><img src="@/assets/icons/wtt-icon12.svg" alt="" /></div>
            <h5>Custom development from scratch</h5>
          </div>
          <div class="col3-grid-item">
            <div><img src="@/assets/icons/wtt-icon13.svg" alt="" /></div>
            <h5>Source code licensing</h5>
          </div>
        </div>
      </div>
    </section>

    <section class="section3 light-gray">
      <div class="section-inner">
        <h2 class="section-title">{{$t('webTradingTerminalPage.text18')}}</h2>
        <p>{{$t('webTradingTerminalPage.text19')}}</p>
        <router-link to="contact" class="contact-us"><BtnPrimary text="Contact us" /></router-link>
      </div>
    </section>
  </div>
</template>

<script>
import BtnPrimary from '@/components/BtnPrimary.vue';

export default {
  name: 'WebTradingTerminal',
  components: { BtnPrimary },
  data() {
    return {};
  },

  mounted() {},

  methods: {
    goContact() {
      this.$router.push('contact')
    }       
  },
};
</script>

<style lang="scss" scoped></style>
